// Central content + imagery. PLACEHOLDER photography - swap with real West Ouachita
// Cabinets shots before launch. All copy drawn from the brand narrative.

export const BUSINESS = {
  name: "West Ouachita Cabinets",
  tagline: "Solid wood. Made here.",
  phone: "(318) 235-7596",
  phoneHref: "tel:+13182357596",
  email: "wocabinets@comcast.net",
  city: "West Monroe, Louisiana",
  addressLine: "710 Adell St, West Monroe, LA 71292",
  serviceArea: "Ouachita Parish & North Louisiana",
  hours: "Mon - Fri, 8:00a - 5:00p",
  mapEmbed:
    "https://www.google.com/maps?q=710+Adell+St,+West+Monroe,+LA+71292&output=embed",
};

export const CTA_LABEL = "Book Your Free 3D Design Consultation";

export const IMAGES = {
  hero: "/projects/p5.jpg",
  craftHands:
    "https://images.unsplash.com/photo-1781032040825-04240013c228?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxDTkMlMjB3b29kJTIwcm91dGVyJTIwbWFjaGluZSUyMGluZHVzdHJpYWwlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODI3MjQxOTF8MA&ixlib=rb-4.1.0&q=85&w=1000",
  shop:
    "https://images.unsplash.com/photo-1764115424769-ebdd2683d5a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxDTkMlMjB3b29kJTIwcm91dGVyJTIwbWFjaGluZSUyMGluZHVzdHJpYWwlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODI3MjQxOTF8MA&ixlib=rb-4.1.0&q=85&w=1000",
  blueprint: "/projects/cad-render.jpg",
  bath:
    "https://images.unsplash.com/photo-1564540579594-0930edb6de43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiYXRocm9vbSUyMHZhbml0eXxlbnwwfHx8fDE3ODM5NjYyMTN8MA&ixlib=rb-4.1.0&q=85&w=1000",
  filigree:
    "https://images.unsplash.com/photo-1594896733292-9a77b5809c63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxnb2xkJTIwZmlsaWdyZWUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4Mzk2NjIxMnww&ixlib=rb-4.1.0&q=85&w=1000",
};

export const GALLERY = [
  {
    id: 1,
    category: "Kitchens",
    title: "White Island Kitchen",
    img: "/projects/p5.jpg",
    real: true,
  },
  {
    id: 2,
    category: "Kitchens",
    title: "Wood Hood & Marble Kitchen",
    img: "/projects/p19.jpg",
    real: true,
  },
  {
    id: 3,
    category: "Kitchens",
    title: "Galley with Waterfall Island",
    img: "/projects/p13.jpg",
    real: true,
  },
  {
    id: 4,
    category: "Baths",
    title: "Vanity & Laundry Suite",
    img: "/projects/p18.jpg",
    real: true,
  },
  {
    id: 5,
    category: "Built-Ins",
    title: "Library Wall Built-In",
    img: "https://images.unsplash.com/photo-1580628881159-4eae247a6bf5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjdXN0b20lMjBidWlsdC1pbiUyMHNoZWx2aW5nJTIwd29vZHdvcmslMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM5NjYzMzR8MA&ixlib=rb-4.1.0&q=85&w=1000",
  },
  {
    id: 6,
    category: "Built-Ins",
    title: "Display Shelving",
    img: "https://images.unsplash.com/photo-1770386482263-ed2340d6214e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxjdXN0b20lMjBidWlsdC1pbiUyMHNoZWx2aW5nJTIwd29vZHdvcmslMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM5NjYzMzR8MA&ixlib=rb-4.1.0&q=85&w=1000",
  },
  {
    id: 7,
    category: "Commercial",
    title: "Executive Office Casework",
    img: "https://images.unsplash.com/photo-1725783521817-3f37e54390a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxjdXN0b20lMjBidWlsdCUyMGluJTIwYm9va3NoZWxmfGVufDB8fHx8MTc4Mzk2NjIxMnww&ixlib=rb-4.1.0&q=85&w=1000",
  },
];

export const GALLERY_CATEGORIES = ["All", "Kitchens", "Baths", "Built-Ins", "Commercial"];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "The Conversation",
    body: "We sit down and listen. How you cook, how you host, how you actually live in the space. No sales script.",
  },
  {
    n: "02",
    title: "Measure & Assess",
    body: "We take precise field measurements in your home and study the architecture, light and flow of every room.",
  },
  {
    n: "03",
    title: "The 3D Design",
    body: "You watch your kitchen take shape on screen in full 3D. Doors, drawers, hardware, finish. Nothing is guessed.",
  },
  {
    n: "04",
    title: "Built In Our Shop",
    body: "Every cabinet is built by our craftsmen in our 8,000 sq ft West Monroe shop. Solid wood, with blind dado drawer boxes standard and dovetail available on request.",
  },
  {
    n: "05",
    title: "Installed To Last",
    body: "We install with the same care we build with, and we stand behind it long after the last screw is set.",
  },
];

export const STANDARDS = [
  { title: "Solid Wood", body: "Real hardwood boxes and doors. No particleboard, no compromise." },
  { title: "No MDF Shortcuts", body: "We do not hide cheap materials behind a painted finish." },
  { title: "Blum Hardware", body: "Soft-close Blum hinges and glides on every door and drawer." },
  { title: "Blind Dado Drawers", body: "Sturdy blind dado drawer boxes standard on every job, with hand-fit dovetail available as an upgrade." },
];

export const BUILD_TYPES = [
  {
    title: "Kitchens",
    body: "The heart of the high-end home. Fully custom cabinetry engineered around how you cook and gather.",
    img: "/projects/p19.jpg",
  },
  {
    title: "Baths",
    body: "Furniture-grade vanities and storage that bring warmth and permanence to the private rooms of the house.",
    img: "/projects/p18.jpg",
  },
  {
    title: "Built-Ins",
    body: "Libraries, entertainment walls, mudrooms and offices designed to look original to the architecture.",
    img: "https://images.unsplash.com/photo-1580628881159-4eae247a6bf5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjdXN0b20lMjBidWlsdC1pbiUyMHNoZWx2aW5nJTIwd29vZHdvcmslMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM5NjYzMzR8MA&ixlib=rb-4.1.0&q=85&w=1000",
  },
  {
    title: "Commercial",
    body: "Reception desks, executive offices and retail casework built to a residential standard of finish.",
    img: "https://images.unsplash.com/photo-1725783521817-3f37e54390a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxjdXN0b20lMjBidWlsdCUyMGluJTIwYm9va3NoZWxmfGVufDB8fHx8MTc4Mzk2NjIxMnww&ixlib=rb-4.1.0&q=85&w=1000",
  },
];

export const REVIEWS = [
  {
    name: "Sarah M.",
    location: "Monroe, LA",
    text: "The 3D design walkthrough sold us. We saw our exact kitchen before a single cabinet was built. The craftsmanship is on another level.",
    stars: 5,
  },
  {
    name: "David & Ann R.",
    location: "West Monroe, LA",
    text: "Solid wood, blind dado drawers, Blum hardware. You can feel the difference the moment you open a drawer. Worth every penny.",
    stars: 5,
  },
  {
    name: "Thomas B.",
    location: "Custom Home Builder",
    text: "I put West Ouachita in every high-end home I build. They make me look good and they never miss a deadline.",
    stars: 5,
  },
];

export const AWARDS = [
  "Best of the Bayou Buzz",
  "Best of Ouachita - Cabinetry",
  "Featured - Residential & Commercial",
  "Preferred Builder Partner",
]; // Best of the Bayou Buzz verified; confirm the rest before launch

export const AWARDS_IMAGE = "/projects/p8.jpg";

export const PROJECT_TYPES = [
  "Kitchen",
  "Bath",
  "Built-Ins",
  "Whole Home",
  "Commercial",
  "Other",
];

export const REFERRAL_SOURCES = [
  "Google Search",
  "Google Business Profile",
  "Referral from a friend",
  "My builder / designer",
  "Social media",
  "Drove by the shop",
  "Other",
];
